import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface PassThroughNoteProps {
  /**
   * Provider shown in the disclosure. Null / blank renders the generic wording
   * (also what the public pricing surface always uses — the internal provider
   * name is never shown to anonymous visitors).
   */
  providerName?: string | null;
  /**
   * Footnote mode: render a visible `*` (not aria-hidden) instead of the info
   * icon, so a `*` on a price chip and this note are visibly + AT associated.
   */
  marker?: boolean;
  className?: string;
}

/**
 * T-448 — pass-through cost disclosure. ClearRing sells the integration at a
 * fixed fee; the third-party provider bills usage separately. Render ONLY for
 * add-ons flagged `isPassThrough`.
 */
export function PassThroughNote({ providerName, marker, className }: PassThroughNoteProps) {
  const { t } = useTranslation('settings');
  const provider = providerName?.trim();
  return (
    <p className={cn('flex items-start gap-1.5 text-xs text-muted-foreground', className)}>
      {marker ? (
        <span className="shrink-0 font-semibold text-foreground">*</span>
      ) : (
        <Info className="mt-0.5 h-3 w-3 shrink-0" aria-hidden="true" />
      )}
      <span>{provider ? t('passThroughDisclosure', { provider }) : t('passThroughDisclosureGeneric')}</span>
    </p>
  );
}
